import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  DislikeOutlined,
  LikeOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";

const status_text = {
  ["-1"]: "Aguardando",
  ["0"]: "Cancelado",
  ["1"]: "Alcançado",
  ["2"]: "Alcançado parcial",
  ["3"]: "Em andamento",
  ["4"]: "Não alcançado",
};

const status_actions_text = {
  ["-1"]: "Não aceito para realização",
  ["0"]: "Não alcançado",
  ["1"]: "Alcançado",
  ["2"]: "Aceito para realização",
  ["3"]: "Aguardando Avaliação",
};

const status = {
  ["-1"]: (
    <Tag color="orange" icon={<ClockCircleOutlined />}>
      Aguardando
    </Tag>
  ),
  ["0"]: <Tag icon={<CloseCircleOutlined />}>Cancelado</Tag>,
  ["1"]: (
    <Tag icon={<CheckCircleOutlined />} color="success">
      Alcançado
    </Tag>
  ),
  ["2"]: (
    <Tag icon={<CheckCircleOutlined />} color="success">
      Alcançado parcial
    </Tag>
  ),
  ["3"]: (
    <Tag icon={<ClockCircleOutlined />} color="processing">
      Em andamento
    </Tag>
  ),
  ["4"]: (
    <Tag icon={<CloseCircleOutlined />} color="error">
      Não alcançado
    </Tag>
  ),
};

const status_actions = {
  ["-1"]: (
    <Tag icon={<DislikeOutlined />} color="error">
      Não aceito para realização
    </Tag>
  ),
  ["0"]: (
    <Tag icon={<CloseCircleOutlined />} color="error">
      Não alcançado
    </Tag>
  ),
  ["1"]: (
    <Tag icon={<CheckCircleOutlined />} color="green">
      Alcançado
    </Tag>
  ),
  ["2"]: (
    <Tag icon={<LikeOutlined />} color="green">
      Aceito para realização
    </Tag>
  ),
  ["3"]: (
    <Tag icon={<ClockCircleOutlined />} color="processing">
      Aguardando Avaliação
    </Tag>
  ),
};

export { status_text, status_actions_text, status, status_actions };
